import MicroModal from 'micromodal';

export default function microModal() {
  const widgetName = 'microModalFeature';
  const widgetOpts = microModalFeatureOpts;

  // Storage selector-------------
  const sectionTrigger = 'homepage';
  const cookiesTimeStamp = 1;
  const buttonText = 'More';

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {
      const d = data.items[0];
      const image = d.ImageWithPath
        ? `<img class="modal__image" alt="${d.Title}" src="${d.ImageWithPath}" />`
        : '';
      const title = d.Title;
      const description =
        d.Description == null ? '' : `<p class="modal__description">${d.Description}</p>`;
      const url =
        d.URL == null ? '' : `<a href="${d.URL}" class="button" target="_blank">${buttonText}</a>`;

      function initializePopupModal() {
        // FORM LAYOUT-------------
        $('body').append(`
            <div class="micromodal-slide" id="modal" aria-hidden="true">
              <div class="modal__overlay" tabindex="-1">
                <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                  <label class="modal-close-btn button" data-micromodal-close>X</label>
                  <div class="modal__content" id="modal-content">
                    <div class="modal__content-left">
                        ${image}
                    </div>
                    <div class="modal__content-right">
                      <h2 class="modal__title" id="modal-title">${title}</h2>
                      ${description}
                      ${url}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `);

        MicroModal.show('modal');
      }

      if (navigator.cookieEnabled && $('#modal') && $('body').hasClass(sectionTrigger)) {
        if (Cookies.get('modalCookie')) {
          return false;
        } else {
          Cookies.set('modalCookie', 'modalCookie', { expires: cookiesTimeStamp });
          initializePopupModal();
        }
      }
    },

    itemsPerPanel: 1,
    link: [],
    maxItemsVisible: 1,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
  });
}
